import axiosInstance from './axiosConfig';

export interface LatestUpdate {
  id: string;
  title: string;
  slug: string;
  published_at: string;
  type: string | null;
  image_url: string | null;
  summary: string | null;
  lp_url: string;
}

export interface LatestUpdateResponse {
  update: LatestUpdate;
}

export interface RecentUpdatesResponse {
  updates: LatestUpdate[];
}

/**
 * 最新のプロダクトアップデート1件を取得（後方互換）。
 * - 200: LatestUpdate を返す
 * - 204: null を返す
 * - 4xx/5xx / ネットワーク障害: null を返す（silent skip）
 */
export async function fetchLatestUpdate(): Promise<LatestUpdate | null> {
  try {
    const response = await axiosInstance.get<LatestUpdateResponse>('/updates/latest', {
      validateStatus: (status) => status === 200 || status === 204,
    });
    if (response.status === 204) {
      return null;
    }
    return response.data?.update ?? null;
  } catch {
    return null;
  }
}

/**
 * 直近 N 件のプロダクトアップデートを取得（カルーセル表示用）。
 * 失敗時は空配列を返す（silent skip）。
 */
export async function fetchRecentUpdates(limit: number = 5): Promise<LatestUpdate[]> {
  try {
    const response = await axiosInstance.get<RecentUpdatesResponse>('/updates/recent', {
      params: { limit },
    });
    return response.data?.updates ?? [];
  } catch {
    return [];
  }
}
